<template>
  <div id="app">

    <body class="body-scroll">
      <!-- Document Wrapper-->
      <div class="wrapper clearfix" id="wrapperParallax">
        <!--   
      Header
      =============================================  
      -->
        <header class="header header-light header-sticky">
          <nav class="navbar navbar-sticky navbar-expand-lg" id="primary-menu">
            <div class="container"> <a class="logo navbar-brand" href="#"><img class="logo logo-dark"
                  src="assets/images/logo/logo-dark.png" alt="LadidApp Logo" /><img class="logo logo-light"
                  src="../src/assets/ict.png" style="width: 40%;" alt="LadidApp Logo" /></a>
              <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarContent"
                aria-expanded="false"><span class="navbar-toggler-icon"></span></button>
              <div class="collapse navbar-collapse" id="navbarContent">
                <ul class="navbar-nav ml-auto">
                  <!-- <li style="color: #7e51ab" v-for="m in menu" :key="m.id">
            <a :href="m.url">{{ m.name }}</a>
          </li> -->
                  <li :class="m.class + ' nav-item'" v-for="m in menu" :key="m.id">
                    <a
                      class="" data-scroll="scrollTo" :href="m.url" style="text-decoration: none;">{{ m.name }}</a></li>
                  <!-- <li class="nav-item"><a class="nav-link" data-scroll="scrollTo" href="#features">Features</a></li>
                <li class="nav-item"><a class="nav-link" data-scroll="scrollTo" href="#screens">screenshots</a></li>
                <li class="nav-item"><a class="nav-link" data-scroll="scrollTo" href="#pricing">pricing</a></li>
                <li class="nav-item"><a class="nav-link" data-scroll="scrollTo" href="#reviews">reviews</a></li>
                <li class="nav-item"><a class="nav-link" data-scroll="scrollTo" href="#news">news</a></li> -->
                </ul>
                <div class="module-container">
                  <!--module-btn-->
                  <div><a class="btn btn-danger" data-scroll="scrollTo" href="#" @click.prevent="logOut"
                      v-if="currentUser"> <span>ออกจากระบบ</span></a></div>
                </div>
                <!-- End Module Container  -->
              </div>
              <!-- End .nav-collapse-->
            </div>
            <!-- End .container-->
          </nav>
          <!-- End .navbar-->
        </header>
      </div>
    </body>
    <router-view />
    <!-- <div v-if="status">
      <router-view />
    </div> -->
    <!-- <div class="row" style="margin-right: 0px" v-else>
      <input type="checkbox" id="check" />
      <label for="check">
        <i class="fa fa-bars" id="btn"></i>
        <i style="color: white" class="fa fa-times" id="cancel"></i>
      </label>
      <div class="sidebar">
        <header>Test</header>
        <ul>
          <li v-if="!currentUser" style="color: #7e51ab">
            <a href="/login">เข้าสู่ระบบ</a>
          </li>
          <li v-if="!currentUser" style="color: #7e51ab">
            <a href="/register">สมัครสมาชิก</a>
          </li>
          <li style="color: #7e51ab" v-for="m in menu" :key="m.id">
            <a :href="m.url">{{ m.name }}</a>
          </li>

          <li style="color: #7e51ab">
            <a href="#" @click.prevent="logOut" v-if="currentUser">ออกจากระบบ</a>
          </li>
        </ul>
      </div>
      <section><router-view /></section>
    </div> -->
  </div>
</template>

<script>
// import Nav from "./components/Nav.vue";
import UserService from "./services/UserService";

export default {
  name: "App",
  data() {
    return {
      status: false,
      menu: [],
    };
  },
  components: {
    // Nav,
  },
  mounted() {
    // console.log('currentUser', this.currentUser);
    if (this.currentUser && this.currentUser.role_id) {
      UserService.getMenuByRole(this.currentUser.role_id).then((res) => {
        // console.log(res.data);
        // this.menu = res.data;
        this.status = false
        for (let m = 0; m < res.data.length; m++) {
          var cla = "";
          if (res.data[m].url == this.$route.fullPath) {
            cla = "active";
          }
          // console.log(cla);

          this.menu.push({
            id: res.data[m].id,
            url: res.data[m].url,
            name: res.data[m].name,
            class: cla,
          });
        }
      }).catch((error) => {
        console.log(error.response);

        if (error.response && error.response.status === 401) {
          localStorage.removeItem('userexam');
          this.$router.push("/");
          setTimeout(() => {
            location.reload();
          }, 500);
        } else {
          console.error("Error loading menu:", error);
        }
      });
    } else {
      this.status = true

    }
  },
  methods: {
    async logOut() {
      await this.$store.dispatch("auth/logout");

      this.$router.push("/"); // ไปหน้า login หรือ home ก่อน

      // reload หลังจาก 500ms เพื่อให้แน่ใจว่า state ถูก reset
      setTimeout(() => {
        location.reload();
      }, 500);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style>
ol,
ul {
  padding-left: 0.5rem;
}

.sidebar {
  position: fixed;
  left: -200px;
  width: 200px !important;
  ;
  height: 100%;
  background: #7e51ab;
  transition: all 0.5s ease;
}

.sidebar header {
  font-size: 20px;
  color: #7e51ab;
  line-height: 40px;
  text-align: center;
  background: #7e51ab;
  user-select: none;
}

.sidebar ul a {
  display: block;
  height: 100%;
  width: 100%;
  line-height: 27px;
  font-size: 12px;
  color: white;
  padding-left: 0px;
  box-sizing: border-box;
  border-bottom: 1px solid black;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  transition: 0.4s;
  text-decoration: none;
}

ul li:hover a {
  padding-left: 15px;
}

.sidebar ul a i {
  margin-right: 10px;
}

#check {
  display: none;
}

label #btn,
label #cancel {
  position: absolute;
  background: #042331;
  border-radius: 3px;
  cursor: pointer;
}

label #btn {
  left: 20px;
  top: 25px;
  font-size: 35px;
  color: white;
  padding: 6px 12px;
  transition: all 0.5s;
}

label #cancel {
  z-index: 1111;
  left: -195px;
  top: 17px;
  font-size: 30px;
  color: #0a5275;
  padding: 4px 9px;
  transition: all 0.5s ease;
}

#check:checked~.sidebar {
  left: 0;
}

#check:checked~label #btn {
  left: 250px;
  opacity: 0;
  pointer-events: none;
}

#check:checked~label #cancel {
  left: 150px;
}

#check:checked~section {
  margin-left: 200px;
}

section {
  background-position: center;
  background-size: cover;
  height: 100vh;
  transition: all 0.5s;
  width: 100%;
}
</style>